<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 

<div class="columns is-vcentered is-gapless" style="margin-bottom:0em;"> 
    <div class="column is-1">
        <button @click="ponderation_new()" class="button is-small is-fullwidth has-background-white has-text-success">
            <span class="icon"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>
    <div class="column is-6 is-size-7 has-text-weight-bold has-text-success">&nbsp;&nbsp;&nbsp;NEW</div>

  <div class="column has-text-centered is-5 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> 
    <button @click="ponderation_save()" class="button is-small is-success is-fullwidth"><span class="icon is-small has-text-white"> <i class="fas fa-save"></i> </span>&nbsp;&nbsp;&nbsp;SAVE</button>
  </div>


</div>


<!-- HEADER  -->
<div class="columns has-text-weight-bold is-centered is-size-7 is-gapless" style="margin-bottom:0em;"> 
  <div class="column is-3 has-background-light">
  <div class="columns is-gapless is-multiline">
    <div class="column is-4">&nbsp;ORDER</div>
    <div class="column is-4">&nbsp;MAX</div>
    <div class="column is-4">&nbsp;PERCENT</div>
  </div></div>

  <div class="column is-6 has-background-light">FR. DESC / EN. DESC</div>
</div>


<!-- //COURSES  -->
<div class="columns is-centered is-gapless" v-for="(data,index) in data_ponderation" :key="index" style="margin-bottom:0em;">


<div class="column colBorder is-3">
<div class="columns is-gapless is-multiline"> 
    <div class="column is-4 is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="data_ponderation[index].isChanged = true" v-model="data_ponderation[index].pond_ORDER" placeholder="order" class="input has-background-warning has-text-centered is-fullwidth"> 
    </div>
    <div class="column is-4  is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="data_ponderation[index].isChanged = true" v-model="data_ponderation[index].pond_MAX" placeholder="max" class="input has-text-centered is-fullwidth"> 
    </div>
    <div class="column is-4   is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="data_ponderation[index].isChanged = true" v-model="data_ponderation[index].pond_PERCENT" placeholder="%" class="input has-text-centered is-fullwidth"> 
    </div>
</div>
</div><!-- END COURSE NAM(s)E  -->



<div class="column colBorder is-4">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="data_ponderation[index].isChanged = true" v-model="data_ponderation[index].pond_DESC_F" placeholder="French" class="input is-fullwidth"> 
    </div>
    <div class="column is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="data_ponderation[index].isChanged = true" v-model="data_ponderation[index].pond_DESC_E" placeholder="English" class="input is-fullwidth"> 
    </div>

</div></div>

<div class="column colBorder is-2">
<div class="columns is-gapless is-multiline">

  <div  @keyup.tab="ponderation_new()" class="column has-text-right is-12 has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
    <button @click="pond_delete_confirm(index)" class="button has-background-danger-light"><span class="icon is-small has-text-grey"> <i class="fas fa-trash-alt"></i> </span></button>
  </div> 





</div></div>


</div>
<!-- END COURSES  -->

</div>
</template>

<script>
import axios from 'axios'


export default {
  name: 'PedCoursePond',
  props: ['cour_id'],

    data() {
        return {
            isLoading:false,
            data_ponderation:[],
        }
    },


created() {
    this.get_ponderation() 
},



methods: {


pond_delete_confirm:function(index) {


    this.$snotify.confirm('Delete Ponderation : ' + this.data_ponderation[index].pond_DESC_F + '?' , { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
    position: "centerCenter",
        buttons: [
            {text: 'Yes', action: (toast) => this.pond_delete_execute(toast,index)},
            {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
        ]
    });


},

pond_delete_execute:function(toast,index) {
this.$snotify.remove(toast.id)
var sql = "DELETE FROM myMEQ_COUR_POND WHERE pond_ID = " + this.data_ponderation[index].pond_ID
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => { 
      this.data_ponderation.splice(index,1)
      this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
});

},


get_ponderation:function() {

var query = "SELECT *, 0 as isChanged, 0 as doDelete FROM myMEQ_COUR_POND WHERE cour_ID = " + this.cour_id + " ORDER BY pond_ORDER"
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
        this.data_ponderation = res.data
        if (this.data_ponderation.length == 0) {this.ponderation_new()}
  });

},


ponderation_new:function() {


// CHECK IF NOTHING
if (this.data_ponderation.length == 0)
{this.data_ponderation.push({pond_ID:0 , isChanged:0 , doDelete:0 ,pond_DESC_F:'',pond_DESC_E:'',pond_PERCENT:'', pond_MAX:'', pond_ORDER:this.data_ponderation.length + 1 })
return;}
 
// CHECK IF ALREADY ONE NEW
// if (this.data_ponderation[0].pond_ID == 0) {return;}

// HERE -- CHUCK ONE IN
this.data_ponderation.push({pond_ID:0 , isChanged:0 , doDelete:0 ,pond_DESC_F:'',pond_DESC_E:'',pond_PERCENT:'', pond_MAX:'', pond_ORDER:this.data_ponderation.length + 1 })


},

ponderation_save:function() {
this.isLoading = true;

  var query = ''
  for (var i = 0; i < this.data_ponderation.length; i++) {


// VALIDATE DATA .... 
if ( this.data_ponderation[i].pond_PERCENT > 0) {
if ( this.data_ponderation[i].pond_MAX > 0) {

      if (this.data_ponderation[i].pond_ID == 0) { // INSERT
        query += "INSERT INTO myMEQ_COUR_POND (cour_ID, pond_DESC_F, pond_DESC_E ,pond_PERCENT , pond_MAX,pond_ORDER) VALUES (" + this.cour_id + ",'" + this.data_ponderation[i].pond_DESC_F.replace(/'/g,"''") + "','" + this.data_ponderation[i].pond_DESC_E.replace(/'/g,"''") + "'," + this.data_ponderation[i].pond_PERCENT + "," + this.data_ponderation[i].pond_MAX + "," + this.data_ponderation[i].pond_ORDER + ");"
      } else {
            query += "UPDATE myMEQ_COUR_POND SET " 
            query += " pond_DESC_F =  '" + this.data_ponderation[i].pond_DESC_F.replace(/'/g,"''")
            query +=  "',pond_DESC_E =  '" + this.data_ponderation[i].pond_DESC_E.replace(/'/g,"''")
            query +=  "', pond_PERCENT =  " + this.data_ponderation[i].pond_PERCENT
            query +=  ", pond_MAX =  " + this.data_ponderation[i].pond_MAX
            query +=  ", pond_ORDER =  " + this.data_ponderation[i].pond_ORDER
            query +=  " WHERE pond_ID =  " + this.data_ponderation[i].pond_ID
            query += " ; "
      } // END CHECKING IF INSERT/UPDATE

}  }

} // END FOR

console.log(query)

// let formData = new FormData();
// formData.append('query', encodeURIComponent(query));
axios({
    method: 'post',
    url: this.$url+sessionStorage.getItem('url_query_form'),
    data: {query:encodeURIComponent(query)},
    
})
.then(res => {
    this.isLoading = false;
})



}, // END SAVE


ponderation_save_XXXX:function(index) {

var query = ''
    if (this.data_ponderation[index].pond_ID == 0) { // INSERT
          
      query = "INSERT INTO myMEQ_COUR_POND (cour_ID) VALUES (" + this.cour_id + ");SELECT MAX(pond_ID) AS newID FROM myMEQ_COUR_POND"
      axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
      .then(res => { 
          this.data_ponderation[index].pond_ID = res.data[0].newID

            query = "UPDATE myMEQ_COUR_POND SET " 
            query += " pond_DESC_F =  '" + this.data_ponderation[index].pond_DESC_F.replace(/'/g,"''")
            query +=  "',pond_DESC_E =  '" + this.data_ponderation[index].pond_DESC_E.replace(/'/g,"''")
            query +=  "', pond_PERCENT =  " + this.data_ponderation[index].pond_PERCENT
            query +=  ", pond_MAX =  " + this.data_ponderation[index].pond_MAX
            query +=  ", pond_ORDER =  " + this.data_ponderation[index].pond_ORDER
            query +=  " WHERE pond_ID =  " + this.data_ponderation[index].pond_ID

console.log(query)

           axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
          .then(res => { 
              this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
              this.data_ponderation[index].isChanged = false
          });           

        });



    } else {
        query = "UPDATE myMEQ_COUR_POND SET " 
        query += " pond_DESC_F =  '" + this.data_ponderation[index].pond_DESC_F.replace(/'/g,"''")
        query +=  "',pond_DESC_E =  '" + this.data_ponderation[index].pond_DESC_E.replace(/'/g,"''")
        query +=  "', pond_PERCENT =  " + this.data_ponderation[index].pond_PERCENT
        query +=  ", pond_MAX =  " + this.data_ponderation[index].pond_MAX
        query +=  ", pond_ORDER =  " + this.data_ponderation[index].pond_ORDER
        query +=  " WHERE pond_ID =  " + this.data_ponderation[index].pond_ID

        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { 
            this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
            this.data_ponderation[index].isChanged = false
        }); 

    }
},
// END SAVE 



check_mobile() {
// RETURN COLLEGE NAME - SHORT FOR MOBILE
if (sessionStorage.getItem('isMobile') == 'true')
  {return true}
  else {return false}
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return sizeM} else {return sizeD} 
},



}

}
</script>


<style scoped>

</style>